export default (data) => ({
    loading: false,
    disabled: false,
    initialAriaLabel: null,

    init() {
        this.initialAriaLabel = this.$el.getAttribute('aria-label');
    },

    /**
     * @param {Boolean} shouldBeDisabled 
     */
    setDisabledStateTo(shouldBeDisabled) {
        this.disabled = shouldBeDisabled;
    },

    /**
     * @param {Boolean} shouldBeLoading 
     */
    setLoadingStateTo(shouldBeLoading) {
        this.loading = shouldBeLoading;
        this.setDisabledStateTo(shouldBeLoading);
    },
});